import { render, staticRenderFns } from "./management-system-flow-form.vue?vue&type=template&id=eb87254e"
import script from "./management-system-flow-form.vue?vue&type=script&lang=js"
export * from "./management-system-flow-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports